import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { ObservableRequestService } from 'app/services/observable-request.service';

import { ConstantsService } from 'app/services/constants-service';

/**
* The service for the Dashboard view.
*/
@Injectable()
export class DnbdashboardService {
    constructor(private requestService: ObservableRequestService) { }

    fetchDnbClients(): Observable<any> {
        return this.requestService.getRequest(
            ConstantsService.DNB_CLIENTS_LIST);
    }
}



// WEBPACK FOOTER //
// ./src/app/dnbdashboard/dnbdashboard.service.ts